import { geographiesTree, geographySmartSearch } from './initialState';
import * as treeUtils from '../components/common/DynamicTree/DynamicGeographyTreeUtils';
import {
  GET_INITIAL_GEOGRAPHY_TREE,
  UPDATE_GEOGRAPHY_TREE_LOAD,
  GET_GEOGRAPHY_TREE_LOAD,
  GET_GEOGRAPHY_SMART_SEARCH,
  CLEAR_GEOGRAPHY_SMART_SEARCH,
  ALL_MARKETS,
} from '../actions/actionTypes';

const initialState = { geographiesTree, geographySmartSearch };
const allMarkets = {
  nodeId: 0,
  parent: 300000,
  name: 'All Markets',
  type: 'L',
  fname: 'INREGION',
};

export default function geographiesReducer(state = initialState, action) {
  switch (action.type) {
    case GET_INITIAL_GEOGRAPHY_TREE:
      return {
        ...state,
        geographiesTree: action.payload,
      };
    case UPDATE_GEOGRAPHY_TREE_LOAD: {
      const updatedProps = {};
      let data = '';
      let deepTreeCopy;
      action.node.forEach(node => {
        if ('active' in node) {
          updatedProps.active = node.active;
        }
        if ('toggled' in node) {
          updatedProps.toggled = node.toggled;
        }
        if (data === '') {
          deepTreeCopy = treeUtils.getDeepTreeCopy(state.geographiesTree);
        } else {
          deepTreeCopy = treeUtils.getDeepTreeCopy(data);
        }

        if (node.nodeId) {
          data = treeUtils.updateTreeNode(
            deepTreeCopy,
            updatedProps,
            node.nodeId,
            node.fname,
          );
        }
      });
      if (data) {
        return {
          ...state,
          geographiesTree: data,
        };
      }
      return state;
    }
    case GET_GEOGRAPHY_TREE_LOAD: {
      if (action.node.nodeId !== 0) {
        const deepTreeCopy = treeUtils.getDeepTreeCopy(state.geographiesTree);
        let data = [];
        if (action.node.nodeId === 300000) {
          data = treeUtils.updateTreeNode(
            deepTreeCopy,
            { children: [allMarkets, ...action.payload.data] },
            action.node.nodeId,
            action.node.fname,
          );
        } else {
          data = treeUtils.updateTreeNode(
            deepTreeCopy,
            { children: action.payload.data },
            action.node.nodeId,
            action.node.fname,
          );
        }
        return {
          ...state,
          geographiesTree: data,
        };
      }
      return {
        ...state,
        geographiesTree: action.payload.data,
      };
    }
    case GET_GEOGRAPHY_SMART_SEARCH: {
      const indexOfFirstMarket = action.payload.data.findIndex(
        item => item.c === 'MARKET',
      );
      action.payload.data.splice(indexOfFirstMarket, 0, ALL_MARKETS);
      return {
        ...state,
        geographySmartSearch: action.payload.data,
      };
    }
    case CLEAR_GEOGRAPHY_SMART_SEARCH: {
      return {
        ...state,
        geographySmartSearch: [],
      };
    }
    default:
      return state;
  }
}
